<template>
  <v-container fill-height fluid>
    <v-row align="center"
           justify="center">
      <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'pt-6 pb-0' : ''" style="max-width: 550px">
        <div class="fin-logo-login"
             style="width: 100%; text-align: center;">
          <fin-logo-full dark
                         size="15em"
                         :class="`${socialLoginInProgress ? '' : dense ? 'mb-1': 'mb-6'}`"/>
        </div>
      </v-col>

      <v-col cols="12" class="py-0 my-0">
        <fin-maintenance-info/>
      </v-col>

      <v-col cols="12" style="max-width: 550px">
        <div :class="$vuetify.breakpoint.xsOnly ? 'mx-10 mb-5' : 'mx-10 mb-5 mt-5'">
          <fin-forgot-password v-if="formState === 'forgotpw'"
                               :dense="dense"
                               @abort="showSignIn"
                               @success="showSignIn"/>
          <fin-data-loader :resolver="fetchData" v-else>
            <fin-sign-in v-if="!socialLoginInProgress"
                         :isSocialMediaAppleActive="isSocialMediaAppleActive"
                         :isSocialMediaGoogleActive="isSocialMediaGoogleActive"
                         @forgotPassword="formState = 'forgotpw'"
                         @socialLoginInProgress="socialLoginInProgress = true"/>
            <fin-social-media-sign-in-in-progress v-else/>
          </fin-data-loader>
          <fin-no-account-yet v-if="!socialLoginInProgress"
                              :class="$vuetify.breakpoint.xsOnly ? 'mt-2' : 'mt-7'"
                              :allow-sign-up="allowSignUp"
                              :form-state="formState"/>
        </div>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import FinDataLoader from '@/components/common/DataLoader/index'
import FinForgotPassword from "@/components/auth/ForgotPassword"
import FinSignIn from "@/components/auth/SignIn"
import FinNoAccountYet from "@/components/navigation/NoAccountYet"
import FinLogoFull from "@/components/common/logo/LogoFull"
import FinMaintenanceInfo from "@/components/common/Maintenance/MaintenanceInfo"
import {API} from "@/plugins/finAmplifyModules"
import {getSystemStatus} from "@/js/finQueries"
import {mapGetters} from "vuex"
import FinSocialMediaSignInInProgress from "@/components/auth/SocialMediaSignInInProgress"

export default {
  name: "Login",
  components: {
    FinSocialMediaSignInInProgress,
    FinDataLoader,
    FinMaintenanceInfo,
    FinLogoFull,
    FinNoAccountYet,
    FinSignIn,
    FinForgotPassword
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'signin'
    }
  },
  data() {
    return {
      drawer: this.value,
      formState: this.mode,
      allowSignUp: process.env.VUE_APP_ALLOW_SIGN_UP === 'true',
      wrapperContent: '',
      dense: false,
      isSocialMediaAppleActive: false,
      isSocialMediaGoogleActive: false,
      socialLoginInProgress: false
    }
  },
  watch: {
    user(newVal){
      if (newVal !== null){
        this.$router.push({name: 'myFinHub'}).catch(() => { })
      }
    },
    drawer(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal) {
      this.drawer = newVal
    },
    mode(newVal) {
      this.formState = newVal
    }
  },
  computed: {
    ...mapGetters('auth', ['publicQueryAuthMode', 'user']),
  },
  methods: {
    calcMenuSize() {
      //TODO
      this.dense = window.innerHeight < 585
    },
    showSignIn() {
      this.formState = undefined
    },
    async fetchData() {
      if (this.$route.query.socialMediaTest === "yes") {
        this.isSocialMediaAppleActive = true
        this.isSocialMediaGoogleActive = true
      } else {
        this.isSocialMediaAppleActive = await this.getSystemStatus("FINCRAFT_APPLE_SIGN_IN")
        //console.log("fetch FINCRAFT_APPLE_SIGN_IN", this.isSocialMediaAppleActive)
        this.isSocialMediaGoogleActive = await this.getSystemStatus("FINCRAFT_GOOGLE_SIGN_IN")
        //console.log("fetch FINCRAFT_GOOGLE_SIGN_IN", this.isSocialMediaGoogleActive)
      }
    },
    async getSystemStatus(id) {
      try {
        const options = {
          query: getSystemStatus,
          variables: {
            id: id
          },
          authMode: this.publicQueryAuthMode
        }
        console.log("options", options)
        const result = await API.graphql(options)
        return result.data.getSystemStatus.status === "TRUE"
      } catch (error) {
        console.error("getSystemStatus failed", error)
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
